import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RplStatusForm from '../../../components/forms/RplStatusForm';
import { useCreateRplStatus } from '../../../hooks/useRplStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { RplStatusDTO } from '../../../services/apiClient';

const RplStatusCreate: React.FC = () => {
  const createRplStatus = useCreateRplStatus();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Rpl Statuses', href: '/admin/rplstatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: RplStatusDTO) => {
    try {
      setIsSubmitting(true);
      await createRplStatus.mutateAsync(data);
      navigate('/admin/rplstatuses');
    } catch (error) {
      console.error('Error creating RplStatus:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/rplstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.RplStatus.Edit'
    >
        <RplStatusForm
          initialValues={{} as RplStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/rplstatuses')}
        />
    </AdminLayout>
  );
};

export default RplStatusCreate;